import { updateBasePriceAction } from "../../../../actions/siteadmin/updateBasePriceAction"
async function submit(values, dispatch) {

    const submittedData = {
        categoryId: values.mainCategoryId,
        subCategoryId: values.id,
        baseFare: values.baseFare,
        profileId: values.profileId,
        currency: values.currency
    }
    await dispatch(updateBasePriceAction(submittedData))
}
export default submit